class InstallAtYourPlace extends HTMLElement {
  abortController = undefined;
  pendingRequestUrl = null;

  constructor() {
    super();

    this.sectionId = this.hasAttribute('data-original-section-id') ? this.getAttribute('data-original-section-id') : this.getAttribute('data-section-id');
    this.variantId = this.dataset.initialVariantId;

    this.elements = {
      contentToggler: this.querySelector('[data-toggle-content]'),
      content: this.querySelector('[data-content]'),
    }

    this.elements.contentToggler.addEventListener('click', this.toggleContent.bind(this));

    this.variantChangeUnsubscriber = theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
      if (event.data.sectionId === this.sectionId) {
        this.handleImageWrapperClick(event);
      }
    });
  }

  toggleContent() {
    this.elements.contentToggler.classList.toggle('opened');
    this.elements.content.slideToggle();
  }

  handleImageWrapperClick(event) {
    const {variant} = event.data;

    if (variant.id != this.variantId) {
      const requestUrl = new URL(window.location.href);
      requestUrl.searchParams.set('variant', variant.id);
      requestUrl.searchParams.set('section_id', this.sectionId);
      this.pendingRequestUrl = requestUrl.href;
      this.abortController?.abort();
      this.abortController = new AbortController();
      
      fetch(requestUrl.href, {signal: this.abortController.signal})
        .then((response) => response.text())
        .then((responseText) => {
          this.pendingRequestUrl = null;
          this.variantId = variant.id;
          const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');

          const newInstallAtYourPlace = parsedHTML.querySelector('install-at-your-place');

          if (this.elements.content) {
            this.elements.content.innerHTML = newInstallAtYourPlace.querySelector('[data-content]').innerHTML;
          } else {
            this.replaceWith(newInstallAtYourPlace);
          }
        })
        .catch((error) => {
        if (error.name === 'AbortError') {
          console.log('Fetch aborted by user');
        } else {
          console.error(error);
        }
      });
    }
  }

  disconnectedCallback() {
    if (this.variantChangeUnsubscriber) {
      this.variantChangeUnsubscriber();
    }
  }
}

customElements.define('install-at-your-place', InstallAtYourPlace);